import { render, staticRenderFns } from "./SnapshotNotice.vue?vue&type=template&id=7e7545ec&scoped=true&"
import script from "./SnapshotNotice.vue?vue&type=script&lang=ts&"
export * from "./SnapshotNotice.vue?vue&type=script&lang=ts&"
import style0 from "./SnapshotNotice.vue?vue&type=style&index=0&id=7e7545ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7545ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/adlandingpage/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e7545ec')) {
      api.createRecord('7e7545ec', component.options)
    } else {
      api.reload('7e7545ec', component.options)
    }
    module.hot.accept("./SnapshotNotice.vue?vue&type=template&id=7e7545ec&scoped=true&", function () {
      api.rerender('7e7545ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SnapshotNotice.vue"
export default component.exports